import { Route } from '@tanstack/react-router';
import { rootRoute } from "../../App"

const AboutPage=()=>{
  return (
    <div>About</div>
  )
}

const AboutRoute = new Route({
    getParentRoute: () => rootRoute,
    path: "/about",
    component: AboutPage,
    })
export default AboutRoute;